export const EMPLOYEE_FIRST_NAME_MAX_CHARACTERS = 40
export const EMPLOYEE_LAST_NAME_MAX_CHARACTERS = 40
export const EMPLOYEE_COST_CENTER_NAME_MAX_CHARACTERS = 40
export const EDIT_EMPLOYEE_FORM_EDIT_CONTENT = 'EDIT_EMPLOYEE_FORM_EDIT_CONTENT'
export const EDIT_EMPLOYEE_FORM_CONFIRMATION_CONTENT =
  'EDIT_EMPLOYEE_FORM_CONFIRMATION_CONTENT'
export const EDIT_EMPLOYEE_FORM_CONFIRMATION_BACK_BUTTON =
  'EDIT_EMPLOYEE_FORM_CONFIRMATION_BACK_BUTTON'
